import { Stack, Typography, StackProps } from '../../../../base-components';
import { useTranslation } from 'react-i18next';

interface IPlaceholderProps extends StackProps {}
const Placeholder = (props: IPlaceholderProps) => {
    const { t } = useTranslation();
    const { sx, ...other } = props;
    return (
        <Stack
            alignItems="center"
            justifyContent="center"
            direction={'column'}
            sx={{
                width: 1,
                textAlign: 'center',
                ...sx,
            }}
            {...other}
        >
            <div>
                <Typography gutterBottom variant="body1" sx={{ margin: 0 }}>
                    {t('uploadFile.dropOrSelect')}
                    <Typography
                        variant="body1"
                        component="span"
                        sx={{
                            mx: 0.5,
                            color: 'primary.main',
                            fontWeight: 600,
                        }}
                    >
                        {t('uploadFile.browse')}
                    </Typography>
                </Typography>

                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {t('uploadFile.dropOrClick')}
                </Typography>
            </div>
        </Stack>
    );
};

export default Placeholder;
